export const getUserDisplayName = (user) => {
  return (
    user.attributes.preferred_username ||
    user.attributes.name ||
    user.attributes.email || 'Unknown'
  );
};
